import { useRouteError } from "react-router-dom";
import { useIsLocal } from "../hooks/useIsLocalhost";
import { isAxiosError } from "../utils/helpers";
import { LocalRailsError } from "./Errors/LocalRailsError";
import { UnknownError } from "./Errors/UnknownError";
import { NotFoundPage } from "./NotFoundPage";

export default function AppErrorPage() {
  const error = useRouteError();
  const isLocal = useIsLocal();

  if (isAxiosError(error)) {
    if (isLocal && error.response?.status === 500) {
      return <LocalRailsError error={error} />;
    } else if (error.response?.status === 404) {
      return <NotFoundPage />;
    }
  }
  return <UnknownError />;
}
